/* eslint-disable prefer-const */

import authState from '../modules/auth/state';
import config from '../config';

export const initialState = {
    backend: config.backend,
    appUrl: config.frontend.app_url,
    orders: null,
    total_orders: 0,
    users: null,
    roles: null,
    suppliers: null,
    buildings: null,
    panel_statuses: null,
    wordings: null,
    // add modules
    auth: authState,
};

export default Object.assign({}, initialState);



// WEBPACK FOOTER //
// ./src/store/state.js